((Drupal) => {
  Drupal.behaviors.nrwLinkExternModal = {
    attach: (context) => {

      const $buttons = once('nrwOpenModal', '.btn.open-modal', context);

      $buttons.forEach(($element) => {

        $element.addEventListener('click', ($event) => {
          $event.preventDefault();
          let $options = {};
          $options.btnLink = $event.currentTarget.getAttribute('href');

          let $nrwModal = Drupal.behaviors.nrwLinkExternModal.getModal();

          const $myModal = new bootstrap.Modal($nrwModal);
          const $content = '<h2 class="h3 mb-4">Weiter zur Antragstellung</h2><p>Sie werden jetzt auf die <strong>externe Website</strong> weitergeleitet, auf welcher der Antrag für dieses Förderprogramm gestellt werden kann.</p>' +
            '<p>Der Link wurde von der für das Förderprogramm zuständigen Stelle hinterlegt.</p><p class="fs-extra-small mb-0">Hinweis: Für Inhalte und Abläufe auf der externen Seite sind die jeweiligen Verantwortlichen zuständig.</p>'
          Drupal.behaviors.nrwLinkExternModal.setModalContent($myModal, '', $content, $options);
          $myModal.show();

        });
      });

    },
    getModal: () => {

      let $modal = document.getElementById('bs-modal-el');
      const $title = '';
      if (!$modal) { $modal =  Drupal.behaviors.nrwLinkExternModal.initModal('external-link-modal', false, $title); }

      return $modal;
    },
    // @Todo: Merge with filter-modal.js
    setModalContent: ($modal, $titleValue, $content, $options) => {
      let $title = $modal._element.querySelector('.modal-title')
      let $body = $modal._element.querySelector('.modal-body');
      let $submitButton = $modal._element.querySelector('#modal-submit-button');

      $title.innerHTML = '';
      $title.innerHTML = $titleValue;

      $body.innerHTML = '';
      $body.innerHTML = $content;

      $submitButton.setAttribute('href', $options.btnLink ? $options.btnLink : '#');

    },
    // @Todo: Merge with filter-modal.js
    initModal: ($classes, $showFooter, $title) => {

      if ($classes === undefined || $classes === false) {
        $classes = '';
      }
      const $buttonReset = Drupal.t('Cancel');
      const $buttonText = Drupal.t('Continue to application');

      let $modal = document.createElement('div');
      $modal.classList.add('modal', 'fade', $classes);
      $modal.setAttribute('id', 'bs-modal-el');
      $modal.setAttribute('tabindex', '-1');
      $modal.setAttribute('role', 'dialog');
      $modal.setAttribute('aria-labelledby', 'modalLabel');
      $modal.setAttribute('aria-hidden', 'true');

      $modal.innerHTML = ' <div class="modal-dialog modal-dialog-centered modal-lg">' +
        '          <div class="modal-content">' +
        '            <div class="modal-header">' +
        '              <h2 class="modal-title fs-5" id="modalLabel"></h2>' +
        '              <button type="button" class="btn fw-normal" data-bs-dismiss="modal" aria-label="' + Drupal.t('Close') + '">' + Drupal.t('Close') + '<i class="fa-solid fa-xmark btn-close ms-2"></i></button>' +
        '            </div>' +
        '            <div class="modal-body"></div>' +
        '            <div class="modal-footer">' +
        '              <button type="button" class="btn btn-white form-reset mt-0 col-lg" data-bs-dismiss="modal">' + Drupal.t($buttonReset) + '</button>' +
        '              <a id="modal-submit-button" class="btn btn-primary mt-0  col-lg" href="#" target="_blank">' + Drupal.t($buttonText) +'</a>' +
        '            </div>' +
        '          </div>' +
        '        </div>'
      // modal.innerHTML =
      //   '<div class="modal-dialog" role="document">' +
      //   '<div class="modal-content"></div>' +
      //   '</div>';


      document.body.appendChild($modal);
      return $modal;
    }
  };
})(Drupal);
